import React, { lazy, Suspense, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Preloader from "../Miscellaneous/Preloader";

const companyComponents = {
    "Customers": lazy(() => import("./Customers")),
};

const DynamicCustomer = () => {
    const { companyName } = useParams();
    const location = useLocation();

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: 'auto' });
        });
    }, [location.pathname]);

    const DecodedName = decodeURIComponent(companyName);

    const Component = companyComponents[DecodedName];

    return (
        <Suspense fallback={<Preloader />}>
            {Component ? <Component /> : <div>Customers screen not found</div>}
        </Suspense>
    );
};

export default DynamicCustomer;
